import { Action, createReducer, on } from '@ngrx/store';

import { Logout, ModelState } from '@personal-area/global/state';
import { Tariff } from '@personal-area/global/accounts/models';

import {
  GetTariffs,
  GetTariffsFail,
  GetTariffsSuccess,
  SetTariffsLoading,
} from '../actions/tariffs';

export interface TariffState extends ModelState {
  tariffs: Tariff[];
}

const initialState: TariffState = {
  tariffs: [],
  isLoading: false,
  isLoaded: false,
};

const _reducer = createReducer(
  initialState,
  on(GetTariffs, (state) => {
    return {
      ...state,
      isLoaded: false, // to enforce a request caused by language change
    };
  }),
  on(GetTariffsSuccess, (state, { tariffs }) => {
    const _tariffs = [...tariffs].map((tariff) => {
      const servers = [...tariff.servers];
      servers.sort((a, b) => (!a.isEnabled ? 1 : -1));
      return {
        ...tariff,
        servers,
      };
    });

    return {
      ...state,
      tariffs: _tariffs,
      isLoading: false,
      isLoaded: true,
    };
  }),
  on(GetTariffsFail, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  }),
  on(SetTariffsLoading, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(Logout, (state) => initialState),
);

export const tariffReducer = (state: TariffState | undefined, action: Action) =>
  _reducer(state, action);
